import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContributionMarginLevelPage } from './contribution-margin-level.page';
import { ContributionMarginLevelDialogModule } from './contribution-margin-level-dialog/contribution-margin-level-dialog.module';


export * from './contribution-margin-level.page';
export * from './contribution-margin-level-dialog/contribution-margin-level-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: ContributionMarginLevelPage,
    },
];

@NgModule({
    declarations: [ ContributionMarginLevelPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        ContributionMarginLevelDialogModule,
        MatProgressBarModule,
        TranslateModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class ContributionMarginLevelPageModule {
}
